import { render, staticRenderFns } from "./DashboardSulut.vue?vue&type=template&id=f6379b5a&lang=pug"
import script from "./DashboardSulut.vue?vue&type=script&lang=js"
export * from "./DashboardSulut.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports